import { css } from 'aphrodite';
import { AgendaWidget, SharedCarousel } from 'components';
import { useScrollToTopOnMount } from 'hooks';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { style } from './style';

export const Agenda: FC<{}> = () => {
  useScrollToTopOnMount();

  const styles = style();
  const cmsData = useSelector((state: RootState) => state.widget.cms.text.agenda_page);

  return (
    <main className={css(styles.main)}>
      <section className={css(styles.section)}>
        <SharedCarousel />

        <div className={css(styles.content)}>
          <AgendaWidget agendaData={cmsData.agenda} darkmode />
        </div>
      </section>
    </main>
  );
};
